import { Button } from '@mui/material';
import styled from 'styled-components';
import colors from './colors';

export const AnchorLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  color: ${(props) => props?.color || colors.light};
  font-size: ${(props) => props?.fontSize || '14px'};
`;

export const TextItem = styled.span.attrs({
  className: 'px-1',
})`
  color: ${(props) => props?.color || colors.light};
  font-size: ${(props) => props?.fontSize || '14px'};
`;

export const StyledButton = styled(Button)`
  &.Mui-disabled {
    pointer-events: all;
    cursor: not-allowed;
    background: ${colors.dark};
  }
`;
